import type { InitialContext } from './chat';
import type { IEventProxy } from './event';
import psHttp from '@patsnap/common-ps-http';

export const HostProps = Symbol('HostProps');

/**
 * 宿主属性
 */
export interface HostProps {
    locale: string;
    httpRequest: typeof psHttp;
    eventProxy: IEventProxy;
    getInitialContext?: () => Promise<InitialContext>;
}
